import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasAccessToken } from "./authStorage";

function ProtectedRoute() {
  const location = useLocation();

  if (!hasAccessToken()) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
